import React from 'react'
import { GoTo } from 'ui/inputs/GoTo'
import { FAQ } from 'services/ContentfulService/models/fact'
import { FaqSectionTop, FaqSectionWrapper, ShowOnDesktop, ShowOnMobile } from './FaqSection.style'
import { truncArray } from 'lib'
import { Stack } from '../../../../components/layout/primitives/Stack'
import { Accordion } from 'ui/surfaces/Accordion'
import { RichText } from 'components/vendor/Contentful/richText/RichTextRenderer'
import { PaddingMod } from 'components/styles/primitives/modifiers/shape/padding'
import { SpaceProperties } from 'components/styles/definitions/size/typographyScale'

interface Props {
	faqs: FAQ[]
	title?: string
}

export const FaqSection: React.FC<React.PropsWithChildren<Props>> = ({
	faqs,
	title = 'Frequently Asked Questions'
}) => {
	if (!faqs.length) {
		return null
	}

	return (
		<FaqSectionWrapper>
			<FaqSectionTop>
				<h2>{title}</h2>
				<ShowOnDesktop>
					<GoTo direction="none" href="/support">
						More Answers
					</GoTo>
				</ShowOnDesktop>
			</FaqSectionTop>
			<Stack modifiers={PaddingMod({ bottom: SpaceProperties.Big })}>
				{truncArray(faqs, 6).map(item => (
					<Accordion key={item.id} title={item.question}>
						<RichText document={item.answer} />
					</Accordion>
				))}
			</Stack>
			<ShowOnMobile>
				<GoTo direction="none" href="/support">
					More Answers
				</GoTo>
			</ShowOnMobile>
		</FaqSectionWrapper>
	)
}
